import { navigate } from 'gatsby';
import { useLingui } from '@lingui/react';
import { setupI18n } from '@lingui/core';
import { en, ja } from 'make-plural';
import { messages as catalogEn } from '../locales/en/messages';
import { messages as catalogJa } from '../locales/ja/messages';

var useI18n = function useI18n(curLocale) {
  var i18n = setupI18n();
  i18n.loadLocaleData({
    en: {
      plurals: en
    },
    ja: {
      plurals: ja
    }
  });
  i18n.load({
    en: catalogEn,
    ja: catalogJa
  });
  i18n.activate(curLocale);
  return {
    i18n: i18n
  };
};

export default useI18n; // TODO: i think this approach is not good..
// toggle en and ja

export var toggleLocaleHandler = function toggleLocaleHandler(i18n, curLocale, path) {
  console.log({
    path: path,
    curLocale: curLocale
  });
  i18n.activate(curLocale === 'en' ? 'ja' : 'en');
  curLocale === 'en' ? navigate(path.replace('en', 'ja')) : navigate(path.replace('ja', 'en'));
}; // get all locale utilities to translate

export var getAllLocaleUtils = function getAllLocaleUtils() {
  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale;
  return {
    i18n: i18n,
    locale: locale
  };
};